require('./src/ui-layout');
module.exports = 'ui.layout';




/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-layout/index.js
 ** module id = 267
 ** module chunks = 0
 **/